import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IBodyContent } from '@wix/thunderbolt-symbols'

type BodyContentFactory = () => IBodyContent

const bodyContent: BodyContentFactory = () => {
	const scriptContent: Array<string> = []

	return {
		appendReactScript: (value) => scriptContent.push(value),
		getReactScripts: () => scriptContent.join('\n'),
	}
}

export const BodyContent = withDependencies([], bodyContent)
